<template>
  <div class="container p-0">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto mt-auto mb-auto">
      <form @submit.prevent="selecionaEmpresaCpfCpnj" v-if="stepLogin === 1">
        <card class="card-login card-white text-left m-0">
          <img
            width="200"
            class="rounded mx-auto d-block p-0"
            src="../../assets/img/logo3.png"
          />

          <div>
            <base-input
              v-if="tipoLogin === 'false'"
              type="tel"
              v-mask="'##.###.###/####-##'"
              v-model="loginEmpresa.cnpj"
              placeholder="CNPJ"
              addon-left-icon="tim-icons icon-bank"
            >
            </base-input>

            <base-input
              v-else
              type="tel"
              v-mask="'###.###.###-##'"
              v-model="loginEmpresa.cpf"
              placeholder="CPF"
              addon-left-icon="tim-icons icon-bank"
            >
            </base-input>
          </div>

          <div class="col-sm-10 checkbox-radios d-flex flex-row p-0">
            <base-radio name="true" v-model="tipoLogin" class="mr-3"
              >CPF</base-radio
            >
            <base-radio name="false" v-model="tipoLogin">CNPJ</base-radio>
          </div>

          <div slot="footer">
            <base-button
              native-type="submit"
              type="success"
              class="mb-3"
              size="lg"
              block
              :disabled="disabledBtnEntrar()"
            >
              Entrar
            </base-button>
          </div>
        </card>
      </form>

      <form @submit.prevent="logarEmpresa" v-if="stepLogin === 2">
        <card class="card-login card-white text-left m-0">
          <img
            width="200"
            class="rounded mx-auto d-block p-0"
            src="../../assets/img/logo3.png"
          />

          <div>
            <base-input
              type="tel"
              v-model="dadosLogin.nome"
              placeholder="Empresa"
              addon-left-icon="tim-icons icon-bank"
              :disabled="true"
            >
            </base-input>

            <base-input
              type="tel"
              v-mask="'###.###.###-##'"
              v-model="loginUsuario.cpf"
              placeholder="CPF"
              addon-left-icon="tim-icons icon-single-02"
            >
            </base-input>

            <base-input
              name="password"
              v-model="loginUsuario.senha"
              type="password"
              placeholder="Senha"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>

          <div slot="footer">
            <base-button
              native-type="submit"
              type="success"
              class="mb-3"
              size="lg"
              block
              :disabled="disabledBtnEntrar()"
            >
              Entrar
            </base-button>
          </div>
        </card>
      </form>
    </div>

    <modal :show.sync="dialogAviso">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Aviso
        </h4>
      </template>
      <div class="row">
        <div class="col-md-12 pr-md-1 text-left">
          <p>
            Informamos que esta opção de acesso é criada pela direção da empresa
            através do login e senha de administrador repassada ao cliente no
            momento da contratação do sistema.<br /><br />

            Caso você deseje ter acesso a plataforma de gestão de pontos da sua
            empresa, solicite ao administrador da empresa que crie um usuário e
            senha a você.<br /><br />

            Caso você já acesse com usuário CNPJ da empresa, é opcional este
            acesso através deste link.<br /><br />

            Nosso suporte não tem permissão para criar login e senha de
            acesso.<br />
          </p>
        </div>
      </div>

      <template slot="footer">
        <div class="w-100 d-flex justify-content-end">
          <base-button type="success" @click="dialogAviso = false"
            >Entendi</base-button
          >
        </div>
      </template>
    </modal>

    <Carregando v-if="isLoading" />
  </div>
</template>

<script>
import { Card, BaseInput } from "@/components/index";
import Carregando from "../../../src/pages/Loads/Carregando.vue";
import swal from "sweetalert2";

import jwt from "jsonwebtoken";
import globalVariable from "../../globalVariable";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Card,
    BaseInput,
    Carregando,
    Modal,
  },
  data() {
    return {
      dialogAviso: true,
      stepLogin: 1,
      dadosLogin: {
        cnpj_login: "",
        db_name: "",
        nome: "",
      },
      isLoading: false,
      tipoLogin: "false", //0 - cpf / 1 - cnpj
      coordenadas: [],
      loginEmpresa: {
        cnpj: "",
        cpf: "",
        senha: "",
      },
      loginUsuario: {
        cpf: "",
        senha: "",
      },
    };
  },
  mounted() {
    this.$getLocation().then((coordinates) => {
      this.coordenadas = coordinates;
    });
  },
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    disabledBtnEntrar() {
      if (
        this.loginEmpresa.cnpj.length == 18 ||
        this.loginEmpresa.cpf.length == 14
      ) {
        return false;
      } else {
        return true;
      }
    },

    async selecionaEmpresaCpfCpnj() {
      let th = this;
      let cpf_cnpj = "";
      this.isLoading = true;
      if (this.tipoLogin == "false") {
        cpf_cnpj = this.loginEmpresa.cnpj.replace(/[. - / - -]/g, "");
      } else {
        cpf_cnpj = this.loginEmpresa.cpf.replace(/[. - / - -]/g, "");
      }

      let bodyFormData = {
        cpf_cnpj_login: cpf_cnpj,
      };

      this.axios
        .post("/api/login/selecionaEmpresaCpfCpnj", bodyFormData)
        .then((response) => {
          th.isLoading = false;

          const dados = response.data.data;
          if (dados.status) {
            this.dadosLogin = dados.dados[0];
            this.stepLogin = 2;
          } else {
            th.showSwal("auto-close", "Erro", dados.err, "error");
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Usuario e Senha Incorreto!",
            "error",
          );
          // warning, error, success, info, and question
        });
    },

    async logarEmpresa() {
      let th = this;
      this.isLoading = true;
      let username = this.loginUsuario.cpf.replace(/[. - / - -]/g, "");

      let bodyFormData = {
        setDB: this.dadosLogin.db_name,
        username,
        password: this.loginUsuario.senha,
      };

      this.axios
        .post("/api/login/loginUsuario", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          const dados = response.data;
          if (dados.status == "fail") {
            th.showSwal("auto-close", "Erro", dados.err, "error");
          } else {
            const expirationTime = 2 * 60 * 60; // 2 horas em segundos (28.800 segundos)

            let w1 = jwt.sign(
              {
                foo: "bar",
                exp: Math.floor(Date.now() / 1000) + 2 * (60 * 60),
              }, // expira em 8 horas
              globalVariable.KEY_LEVEL_5,
            );
            let usuario = response.data.data;
            delete usuario.restricaoEmpresa;
            th.$cookies.set("w_", w1, expirationTime);
            th.$cookies.set("cnpj", th.dadosLogin.cnpj_login);
            th.$cookies.set("db", th.dadosLogin.db_name);
            th.$cookies.set("nome_empresa", th.dadosLogin.nome);
            th.$cookies.set("usuario", usuario);
            th.$cookies.set("id_actor", usuario.id); // para logs
            th.$cookies.set("tipo_actor", "RH"); // para logs
            th.$cookies.set(
              "token",
              "sbchascas6aa6sd34h23vg42v3hg4gh234vhg234vgh2",
              expirationTime,
            ); // expira em 2 horas
            th.recuperarDados(
              th.dadosLogin.db_name,
              "/home",
              th.dadosLogin.cnpj_login,
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", err.response.data.err, "error");
          // warning, error, success, info, and question
        });
    },

    recuperarDados(db, route, cnpj) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: db,
        cpf_cnpj: cnpj,
      };

      this.axios
        .post("/api/empregador/listarEmpregadorPorCpfCpnj", bodyFormData)
        .then((response) => {
          let dados = response.data.data.dados[0];
          th.isLoading = false;
          th.$cookies.set("idEmpregador", dados.id);
          th.$router.push(route);
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao recuperar dados!",
            "error",
          );
        });
    },
  },
};
</script>

<style>
.full-page > .content {
  padding-top: 10%;
}
</style>
